import { api } from "@/api/api";
import { paramsReducer } from "@/api/utils";
import type {
  ApiResponse,
  DocumentPatchWrite,
  DocumentRead,
} from "@/types/api/types";

export const DocumentsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getModuleDocuments: builder.query<
      ApiResponse<DocumentRead>,
      { moduleUuid: string; [key: string]: any }
    >({
      query: ({ moduleUuid, ...params }) =>
        paramsReducer(`documents/module/${moduleUuid}`, params),
      providesTags: ["Documents"],
    }),
    getModuleParticipationDocuments: builder.query<
      ApiResponse<DocumentRead>,
      { moduleUuid: string; [key: string]: any }
    >({
      query: ({ moduleUuid, ...params }) =>
        paramsReducer(`documents/module/${moduleUuid}/participations`, params),
      providesTags: ["Documents"],
    }),
    getLaboratoryDocuments: builder.query<
      ApiResponse<DocumentRead>,
      { laboratoryUuid: string; [key: string]: any }
    >({
      query: ({ laboratoryUuid, ...params }) =>
        paramsReducer(`documents/laboratory/${laboratoryUuid}`, {
          type: "certificate",
          ...params,
        }),
      providesTags: ["Documents"],
    }),
    getParticipationDocuments: builder.query<
      ApiResponse<DocumentRead>,
      { participationUuid: string; [key: string]: any }
    >({
      query: ({ participationUuid, ...params }) =>
        paramsReducer(`documents/participation/${participationUuid}`, params),
      providesTags: ["Documents"],
    }),
    createDocument: builder.mutation<DocumentRead, FormData>({
      query: (data) => ({
        url: "documents",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Documents"],
    }),
    patchDocument: builder.mutation<
      DocumentRead,
      { uuid: string; data: DocumentPatchWrite }
    >({
      query: ({ uuid, data }) => ({
        url: `documents/${uuid}`,
        method: "PATCH",
        body: JSON.stringify(data),
        headers: { "Content-Type": "application/merge-patch+json" },
      }),
      invalidatesTags: ["Documents"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetModuleDocumentsQuery,
  useGetModuleParticipationDocumentsQuery,
  useGetLaboratoryDocumentsQuery,
  useGetParticipationDocumentsQuery,
  useCreateDocumentMutation,
  usePatchDocumentMutation,
} = DocumentsApi;
